/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingProgress {
    getFixupPrototypeFunction() { return CostProcessingProgress.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingProgress>): CostProcessingProgress {
        let obj = Object.assign(new CostProcessingProgress(), model);
        CostProcessingProgress.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingProgress>): CostProcessingProgress {
        if (!model) return null;
        return CostProcessingProgress.newInstance(<CostProcessingProgress> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingProgress) {
        if (!obj) return;

        models.CostProcessingProgress.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingProgress): boolean {
        Object.setPrototypeOf(obj, CostProcessingProgress.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_records_processed === undefined) {
            this.total_records_processed = 0;
        }
    }

    /**
     * Total number of records processed from all files
     */
    total_records_processed: number;

}
